import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import CaretDown from "Images/profile/CaretDown.svg";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import styles from "./styles.module.scss";
import Chatbox from "../../DietitianPage/Chatbox/Chatbox";
import { rdData } from "../YourRD";
const RdChatPage = ({ goBack }) => {
    const myRD = useSelector((state) => state.dietitian);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return myRD.assigned_RD ? (_jsxs("div", { className: styles.chat, children: [_jsxs("div", { className: styles.title_wrapper, children: [_jsx("div", { role: "button", tabIndex: 0, onKeyDown: () => null, className: styles.back, onClick: goBack, children: _jsx("img", { src: CaretDown, alt: "" }) }), _jsxs("div", { className: styles.title, children: ["Chat With\u00A0", myRD.assigned_RD] }), _jsx("div", {})] }), _jsx(Chatbox, { dietitianPhoto: rdData[myRD.assigned_RD].image })] })) : null;
};
export default RdChatPage;
